import React from 'react';
import PropTypes from 'prop-types';

const createReactClass = require('create-react-class');

const RightCaret = createReactClass({
  render() {
    return (
      /* eslint-disable */
      <svg className="caret-right" id="assets" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
        <polygon className="caret-right" points="4.28 12.63 8.82 8.09 4.28 3.56 6.05 1.79 12.35 8.09 6.05 14.4 4.28 12.63"/>
      </svg>
      /* eslint-enable */
    );
  },
});

const AlertExplanation = createReactClass({
  propTypes: {
    display: PropTypes.string,
  },
  render() {
    const display = this.props.display ? this.props.display : 'none';
    const SVGstyle = {
      fill: '#dd2222',
      display: display,
      border: '2px solid green',
    };
    return (
      /* eslint-disable */
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 16 16" role="img" title="alert-explanation">
        <path id='alert' style={SVGstyle} d="M7,11H9v2H7ZM7,5H9v5H7Zm.73-3.86L0,14.72c-.12.19,0,.28.27.28H15.68c.23,0,.4-.09.27-.28L8.27,1.14A.33.33,0,0,0,7.73,1.14Z" data-name="Layer%201"/>
      </svg>
      /* eslint-enable */
    );
  },
});

export { AlertExplanation, RightCaret };
